<template>
    <div class="hc-loading" :class="{ 'hc-mask': full }" v-if="showLoading">
        <fa-icon icon="asterisk" size="3x" spin></fa-icon>
        <div class="h5 mt-3">{{ loadingText }}</div>
    </div>
</template>

<script>
export default {
    name: "HecLoading",
    props: {
        full: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            defaultText: "Loading...",
            loadingText: null,
            showLoading: false
        };
    },
    mounted() {
        this.$root.$on("loadingStart", message => {
            this.startLoading(message);
        });
        this.$root.$on("loadingEnd", () => {
            this.stopLoading();
        });
    },
    methods: {
        startLoading(message) {
            this.loadingText = message ? message : this.defaultText;
            this.showLoading = true;
        },
        stopLoading() {
            this.showLoading = false;
        }
    }
};
</script>

<style scoped lang="scss">
.hc-loading {
    @include flex-center-xy;
    flex-direction: column;
    text-align: center;
    padding: $spacer;

    svg {
        color: $hec-orange;
    }
}
</style>
